module.exports = {
  'EUR': { value: 'EUR', symbol: '€', countryIds: [1, 2, 4] },
  'CHF': { value: 'CHF', symbol: 'CHF', countryIds: [3] },
}
